import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { TvLoginStore } from '../../pages/app/services/app.store';

@Injectable({
  providedIn: 'root',
})
export class AppTranslateService {
  readonly #tvLoginStore = inject(TvLoginStore);
  readonly #translate = inject(TranslateService);
  static defaultSystemLanguageId = 1;

  resetAllLanguages() {
    this.#translate.getLangs().forEach((languageId) => {
      this.#translate.resetLang(languageId);
    });
  }

  setLanguage(languageId: number | string) {
    const stringLanguageId = languageId + '';
    this.#tvLoginStore.translationReset();

    return this.getLanguage(stringLanguageId).then(() => {
      this.#tvLoginStore.translationLoadedForTheFirstTimeSuccessfully();
    });
  }

  setDefaultLanguage() {
    const stringSystemLanguageId = AppTranslateService.defaultSystemLanguageId + '';

    this.#translate.setDefaultLang(stringSystemLanguageId);
    return this.setLanguage(stringSystemLanguageId);
  }

  private useLanguage(languageId: string) {
    return this.#translate.use(languageId).toPromise();
  }

  private getLanguage(languageId: string) {
    return this.#translate.currentLoader
      .getTranslation(languageId)
      .toPromise()
      .then(() => this.useLanguage(languageId));
  }
}
